module.exports = __webpack_public_path__ + "static/2019-whistle-share.d39a4007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2019-whistle-share.jpg
// module id = 919
// module chunks = 263791100135453